import { Button, Dropdown, Tooltip, useDrawer } from '@iveco-ti/iveco-ds'
import { Megaphone, Newspaper, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useGetUserInfo } from '@/common/hooks/useGetUserInfo'

export function DropdownButtonCreateNews() {
  const { t } = useTranslation('panel')
  const { userInfo } = useGetUserInfo()
  const drawerCreateNewsHighlighted = useDrawer(
    'drawer-create-news-highlighted',
  )
  const drawerCreateNews = useDrawer('drawer-create-news')

  if (!userInfo?.UserPreference?.allowedPosts) return null

  return (
    <Tooltip text={t('news.search_bar.new_post_button.tooltip')}>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <Button.Root variant="primary">
            <Button.Icon icon={Plus} />
          </Button.Root>
        </Dropdown.Trigger>

        <Dropdown.Body>
          <Dropdown.List>
            <Dropdown.Item onClick={drawerCreateNewsHighlighted.open}>
              <Dropdown.Icon icon={<Megaphone size={16} />} />
              {t('news.search_bar.new_post_button.types.highlighted')}
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => {
                drawerCreateNews.open()
              }}
            >
              <Dropdown.Icon icon={<Newspaper size={16} />} />
              {t('news.search_bar.new_post_button.types.default')}
            </Dropdown.Item>
          </Dropdown.List>
        </Dropdown.Body>
      </Dropdown.Root>
    </Tooltip>
  )
}
